<script setup>
import { watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const pageMeta = {
  home: {
    title: 'Home | Data Do - Agentic AI & Data Engineering',
    description: 'Data Do GmbH — Architecting Scalable AI & Data Engineering Solutions. From Raw Data to Production-Ready AI.'
  },
  'audit-request': {
    title: 'AI & Data Audit | Data Do - Agentic AI & Data Engineering',
    description: 'Request a comprehensive AI and data engineering audit from Data Do GmbH. Identify opportunities for automation and optimization.'
  },
  'enterprise-rag-book': {
    title: 'Enterprise RAG Book | Data Do - Agentic AI & Data Engineering',
    description: 'Explore our Enterprise RAG implementation guide — production-grade Retrieval-Augmented Generation for enterprise knowledge management.'
  }
}

function updateMeta() {
  const name = route.name || 'home'
  const meta = pageMeta[name] || pageMeta.home

  document.title = meta.title

  setMetaTag('name', 'description', meta.description)
  setMetaTag('property', 'og:title', meta.title)
  setMetaTag('property', 'og:description', meta.description)
  setMetaTag('property', 'og:type', 'website')
  setMetaTag('property', 'og:url', `https://data-do.com${route.fullPath}`)
}

function setMetaTag(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

onMounted(updateMeta)
watch(() => route.name, updateMeta)
</script>
